import React from "react";
import PropTypes from "prop-types";
import { withSearch } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";

const NoResultView = withSearch(({ results, isLoading }) => ({
  results,
  isLoading,
}))(({ results, isLoading }) => {
  const hideNoResult = results.length > 0;
  const { t } = useTranslation();

  return !hideNoResult && !isLoading
    ? t(
        "The page you are looking for could not be found. Please try a different keyword.",
      )
    : null;
});

function ResultsView({ children, className, results, ...rest }) {
  return (
    <div className="p-result">
      {children}
      <NoResultView />
    </div>
  );
}

ResultsView.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ResultsView;
